module.exports = __webpack_public_path__ + "static/media/Buffalo King.6e5122b5.png";